import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ErrorCode } from "@root/config";
import { NzMessageService } from "ng-zorro-antd/message";
import { EMPTY, Observable, filter, of, tap } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private msg: NzMessageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      filter((e) => e instanceof HttpResponse),
      tap((event: HttpResponse<any>) => {
        if (!event.body) {
          return EMPTY;
        }

        const hideError = req.headers.get("hostex-hide-error");
        if (hideError === "yes") {
          return of(event);
        }

        const code = event?.body?.error_code;
        if (code && code !== ErrorCode.Success && code !== -1 && !this.inErrorAlertForbiddenList(req.url)) {
          this.msg.warning(event.body.error_msg, {
            nzDuration: 4000,
          });
        }
      }),
    );
  }

  // 有一些请求不需要弹错误
  private inErrorAlertForbiddenList(url: string) {
    return url.startsWith("/app/assets");
  }
}
